import React from "react";
import { useTranslation } from "react-i18next";
import { useUserPreferencesRetrieval } from "@planzone/view-models";

function LanguageWatcher() {
  const { i18n } = useTranslation();
  const { preferences } = useUserPreferencesRetrieval();

  React.useEffect(() => {
    i18n
      .changeLanguage(preferences.language)
      .then(console.log)
      .catch(console.log);
  }, [preferences.language]);

  return <React.Fragment />;
}

export { LanguageWatcher };
